export const GRIA_URL = process.env.REACT_APP_GRIA_URL ?? '';
export const AUTH_URL = process.env.REACT_APP_PUBLIC_URL ?? '';
export const WORDPRESS_URL = process.env.REACT_APP_WORDPRESS_URL ?? '';
export const TERMS_VERSION = process.env.REACT_APP_TERMS_VERSION ?? '';

export const ROUTES = {
  AUTHENTICATION: '/',
  ACCESS_CODE: '/access-code',
  DIDINT_RECEIVE_CODE: '/didnt-receive-code',
  REQUIREMENTS: '/requirements',
  CREATE_COMPANY: '/create-company',
  FORM_COMPANY: '/form-company',
  CAREER: '/carreira',
  SLOGAN: '/slogan',
  TERMS: '/terms',
  LOGIN_LINKEDIN: '/login-linkedin',
  INVITED_USER: '/invited-user'
};

export const PUBLIC_ROUTES = [
  ROUTES.AUTHENTICATION,
  ROUTES.ACCESS_CODE,
  ROUTES.DIDINT_RECEIVE_CODE,
  ROUTES.LOGIN_LINKEDIN
];

export const VALID_ACTIONS = ['job_open', 'application', 'company_invite'];
